import { SummaryRow } from "namirasoft-balance";
import { TimeOperation } from "namirasoft-core";
import { MoneyFormatter } from "namirasoft-site-react";
import Styles from "./SummaryStatement.module.css";

interface SummaryStatementLineProps
{
    row: SummaryRow;
    assetName: string;
    title?: string;
    subtitle?: string;
}

function formatAmount(assetName: string, value: number): string
{
    return new MoneyFormatter(undefined, assetName).format(value);
}

export function SummaryStatementLine(props: SummaryStatementLineProps)
{
    const { row, assetName } = props;
    const monthLabel = TimeOperation.MONTH_NAMES[(row.month - 1) % 12] ?? String(row.month);
    const net = row.final_balance - row.previous_balance;
    const title = props.title ?? `${monthLabel} ${row.year}`;
    const subtitle = props.subtitle ?? "Monthly account statement";

    return (
        <div className={Styles.statement_card}>
            <div className={Styles.statement_header}>
                <div className={Styles.statement_header_left}>
                    <div className={Styles.statement_period}>
                        {title} <span className={Styles.statement_subtitle}>({subtitle})</span>
                    </div>
                </div>
            </div>
            <div className={Styles.statement_body}>
                <div className={Styles.statement_cell}>
                    <div className={Styles.cell_label}>Opening balance</div>
                    <div className={Styles.cell_value}>{formatAmount(assetName, row.previous_balance)}</div>
                </div>
                <div className={Styles.statement_cell}>
                    <div className={Styles.cell_label}>
                        <span className={`${Styles.badge} ${Styles.badge_down}`}>−</span>
                        Invoices
                    </div>
                    <div className={`${Styles.cell_value} ${Styles.cell_value_debit}`}>
                        {formatAmount(assetName, row.total_debt)}
                    </div>
                </div>
                <div className={Styles.statement_cell}>
                    <div className={Styles.cell_label}>
                        <span className={`${Styles.badge} ${Styles.badge_up}`}>+</span>
                        Payments
                    </div>
                    <div className={`${Styles.cell_value} ${Styles.cell_value_credit}`}>
                        {formatAmount(assetName, row.total_credit)}
                    </div>
                </div>
                <div className={Styles.statement_cell}>
                    <div className={Styles.cell_label}>Net change</div>
                    <div className={`${Styles.cell_value} ${net > 0 ? Styles.cell_value_debit : net < 0 ? Styles.cell_value_credit : Styles.cell_value}`}>
                        {net > 0 ? "+" : net < 0 ? "−" : ""} {formatAmount(assetName, Math.abs(net))}
                    </div>
                </div>
                <div className={Styles.statement_cell}>
                    <div className={Styles.cell_label}>Closing balance</div>
                    <div className={Styles.cell_value}>{formatAmount(assetName, row.final_balance)}</div>
                </div>
            </div>
        </div>
    );
}